import React, { useState } from 'react'
import { objectToOptions } from 'Utilities/selectOptions'
import { uniqBy, map, flatten } from 'lodash'

import { filteredVMData } from '../Data'
import { defaultFilters } from '../Filters'
import Summary from './Summary'
import SoftwareReportContext from '../SoftwareReportContext'

const CloudCoreSoftwareDatacentersReport = ({ vms }) => {
  const [filters, changeFilters] = useState(defaultFilters)
  const toggleSummary = (showSummary = true, currentView) => changeFilters({ ...filters, showSummary })
  const showNonSummarisedData = (filter, chosenOption) => changeFilters({ filters: { ...filters, [filter]: [chosenOption] } })
  const filterOptions = {
    clusters: objectToOptions(vms, 'cluster_name'),
    customers: uniqBy(map(vms, vm => ({ value: vm.viaje_client_id, label: vm.customer_name })), 'label'),
    locations: uniqBy(map(vms, vm => ({ value: vm.location_id, label: vm.location_name })), 'label'),
    operating_systems: objectToOptions(vms, 'operating_system'),
    machine_type_sources: objectToOptions(vms, 'machine_type_source'),
    vendors: objectToOptions(vms, 'vendor'),
    editions: objectToOptions(vms, 'operating_system_edition'),
    functions: objectToOptions(map(vms, 'cluster'), 'function'),
    ownerships: objectToOptions(map(vms, 'cluster'), 'ownership'),
  }

  return (
    <SoftwareReportContext.Provider value={{ filterOptions, filters, changeFilters, showNonSummarisedData, toggleSummary }}>
      <Summary {...{ data: flatten(filteredVMData({ vms, filters })) } } />
    </SoftwareReportContext.Provider>
  )
}

export default CloudCoreSoftwareDatacentersReport
